export default __webpack_public_path__ + "static/media/ic_ticket_white.b373a5ce.png";